// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","list":"list--3AUUO","actions":"actions--ns8vh"};